/**
 * @file
 * Contains logic and setting differences between metadata forms.
 */

const metadataHelper = {
  messages: {
    submitted: function (type) {
      switch (type) {
        case "sds_file":
        case "sds_url":
        case "chemdb_type_file":
        case "chemdb_type_url":
          return "Attachment complete.";
        default:
          return "Data submitted.";
      }
    },
  },
  getPlaceholder: function (type, field) {
    switch (type) {
      case "sds_url":
      case "chemdb_type_url":
        if (field === "field_chemdb_type_related_url") {
          return "Include full URL with https://";
        }
        return "";
      default:
        return false;
    }
  },
  renderField: function (type, field, form) {
    switch (type) {
      case "sds_file":
      case "sds_url":
      case "chemdb_type_file":
      case "chemdb_type_url":
        if (field === "field_current" && form === "add") {
          return false;
        }
        if (type === "sds_file" && field === "association" && form === "add") {
          return false;
        }
        return true;
      default:
        return true;
    }
  },
  modifySubmissionData(type, form, data) {
    switch (type) {
      case "sds_file":
      case "sds_url":
      case "chemdb_type_file":
      case "chemdb_type_url":
        if (form === "add") {
          data.attributes.field_current = [];
          data.attributes.field_current[0] = { value: true };
        }
        break;

      default:
        break;
    }
  },
};

export default metadataHelper;
